import {J_Array} from '@/model/src/sections/section-j-plus/constants';
import {Field} from '@/model/types';

export const seededFromCompMarkerField = <TArray extends J_Array>(array: TArray): string => `${array}_seededFromComp`;

export const seededFromCompMarkerFieldDefinition = <TArray extends J_Array>(array: TArray) =>
  ({
    id: seededFromCompMarkerField(array),
    type: 'hidden',
    label: {
      fr: 'A été pré-complété à partir des données du compte',
      en: 'Was pre-filled from account data',
    },
    initialValue: '',
  }) as const satisfies Field;
